export default __webpack_public_path__ + "static/media/win.61b1ea42.png";